































import {Component, Prop, Watch} from 'vue-property-decorator';
import ChunForm from '@/mixins/ChunForm';
import {VFormData} from '@/utils/VFormData';
import {createSupplier, updateSupplier} from '@/services/SupplierService';
import ProductSelect from '@/components/ProductSelect.vue';
import {ISupplier} from '@/models/ISupplier';
import {LayoutModule} from '@/store/modules/LayoutModule';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

interface ISupplierFormData {
  name: string;
  email: string;
  products: number[];
}


@Component({
  components: {
    ProductSelect
  }
})
export default class SupplierForm extends ChunForm {
  @Prop() supplier?: ISupplier;
  @Prop({default: false}) isEdit!: boolean;
  loading: boolean = false;
  formData: VFormData<ISupplierFormData> = new VFormData<ISupplierFormData>(
      {
        email: '',
        name: '',
        products: []
      }
  );

  @Watch('supplier', {immediate: true})
  onSupplierChange() {
    if (this.supplier) {
      this.formData.data.email = this.supplier.email;
      this.formData.data.name = this.supplier.name;
      this.formData.data.products = this.supplier.products.map((product) => product.id);
    }
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }


  async create() {
    try {
      this.loading = true;
      const {name, email, products} = this.formData.data;
      const res = await createSupplier(this.organizationId, this.shopId, name, email, products);
      if (res.status === 422) {
        this.extractError(res);
        return;
      }
      if (res.status === 200) {
        await this.$router.replace({name: 'dashboard.suppliers'});
      }
    } finally {
      this.loading = false;
    }
  }

  async edit() {
    try {
      this.loading = true;
      const {name, email, products} = this.formData.data;
      const res = await updateSupplier(this.organizationId, this.shopId, this.supplier!.id, name, email, products);
      if (res.status === 422) {
        this.extractError(res);
        return;
      }
      if (res.status === 200) {
        LayoutModule.showNotification({text: 'Success'});
      }
    } finally {
      this.loading = false;
    }
  }
}
